export default __webpack_public_path__ + "static/media/master.300739d7.svg";